import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { QuestionnaireContextProvider } from '../../context/questionnaire';
import QuestionnaireSliderComponent from '../../components/questionnaire/slider';
import { QuestionnaireType } from '../../entities/questionnaire-type';
import { pushGTMEvent, GTM_EVENTS } from '../../utils/gtm-events';

export default function QuestionnaireRepeatPageComponent() {
  const { orderHash, productId, extraSurveyId } = useParams();
  let intProductId = 0;
  let intExtraSurveyId = 0;

  if (typeof productId === 'string') {
    intProductId = parseInt(productId, 10);
  }

  if (typeof extraSurveyId === 'string') {
    intExtraSurveyId = parseInt(extraSurveyId, 10);
  }

  useEffect(() => {
    if (orderHash && productId) {
      pushGTMEvent(GTM_EVENTS.START_QUIZ, {
        order_hash: orderHash,
        product_id: parseInt(productId, 10),
      });
    }
  }, [orderHash, productId]);

  return (
    <QuestionnaireContextProvider
      type={QuestionnaireType.Onboarding}
      productId={intProductId}
      repeatOrderHash={orderHash}
      extraSurveyId={intExtraSurveyId}
    >
      <QuestionnaireSliderComponent productId={intProductId} />
    </QuestionnaireContextProvider>
  );
}
